import { initSplideCarousel } from '@/splide-carousel';

/** Tailwind breakpoints (max-width, for Splide's default `mediaQuery: 'max'`). */
const XL_MAX = 1279;
const LG_MAX = 1023;
const SM_MAX = 639;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-image-carousel').forEach((block) => {
		initSplideCarousel(block, {
			perPage: 3,
			perMove: 1,
			gap: '2rem',
			trimSpace: 'move',
			breakpoints: {
				[XL_MAX]: {
					gap: '1.25rem',
				},
				[LG_MAX]: {
					perPage: 2,
					gap: '1.25rem',
				},
				[SM_MAX]: {
					perPage: 1,
				},
			},
		});
	});
});
